<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_13">Abbreviations</a></h1><a id="page_13">
<p class="abbre-para"><span class="abbre">AB</span>Anchor Bible</p>
<p class="abbre-para"><span class="abbre">ABRL</span>Anchor Bible Reference Library</p>
<p class="abbre-para"><span class="abbre"><em>ATR</em></span><em>Australasian Theological Review</em></p>
<p class="abbre-para"><span class="abbre">BECNT</span>Baker Exegetical Commentary on the New Testament</p>
<p class="abbre-para"><span class="abbre"><em>BTB</em></span><em>Biblical Theology Bulletin</em></p>
<p class="abbre-para"><span class="abbre">BZNW</span>Beihefte zur Zeitschrift für neutestamentliche Wissenschaft</p>
<p class="abbre-para"><span class="abbre"><em>CBQ</em></span><em>Catholic Biblical Quarterly</em></p>
<p class="abbre-para"><span class="abbre"><em>CTR</em></span><em>Criswell Theological Review</em></p>
<p class="abbre-para"><span class="abbre"><em>DJG</em></span><em>Dictionary of Jesus and the Gospels</em></p>
<p class="abbre-para"><span class="abbre">HKAT</span>Handkommentar zum Alten Testament</p>
<p class="abbre-para"><span class="abbre">ICC</span>International Critical Commentary</p>
<p class="abbre-para"><span class="abbre"><em>Int</em></span><em>Interpretation</em></p>
<p class="abbre-para"><span class="abbre"><em>JBL</em></span><em>Journal of Biblical Literature</em></p>
<p class="abbre-para"><span class="abbre"><em>JR</em></span><em>Journal of Religion</em></p>
<p class="abbre-para"><span class="abbre">JSNTSup</span>Journal for the Study of the New Testament: Supplement Series</p>
<p class="abbre-para"><span class="abbre"><em>JTS</em></span><em>Journal of Theological Studies</em></p>
<p class="abbre-para"><span class="abbre">NCB</span>New Century Bible</p>
<p class="abbre-para"><span class="abbre">NIGTC</span>New International Greek Testament Commentary</p>
<p class="abbre-para"><span class="abbre"><em>NovT</em></span><em>Novum Testamentum</em></p>
<p class="abbre-para"><span class="abbre">NTL</span>New Testament Library</p>
<p class="abbre-para"><span class="abbre"><em>NTS</em></span><em>New Testament Studies</em></p>
<p class="abbre-para"><span class="abbre">NTTS</span>New Testament Tools and Studies</p>
<p class="abbre-para"><span class="abbre"><em>SBLSP</em></span><em>Society of Biblical Literature Seminar Papers</em></p>
<p class="abbre-para"><span class="abbre">SBLSBS</span>Society of Biblical Literature Sources for Biblical Studies</p>
<p class="abbre-para"><span class="abbre">SBT</span>Studies in Biblical Theology</p>
<p class="abbre-para"><span class="abbre"><em>TDNT</em></span><em>Theological Dictionary of the New Testament. Edited by G. Kittel and G. Friedrich. Translated by G. W. Bromiley. 10 vols. Grand Rapids, 1964–1976.</em></p>
<p class="abbre-para"><span class="abbre">TNTC</span>Tyndale New Testament Commentaries</p>
<p class="abbre-para"><span class="abbre"><em>TS</em></span><em>Theological Studies</em></p>
<p class="abbre-para"><span class="abbre">WBC</span>Word Biblical Commentary</p>
<p class="abbre-para"><span class="abbre">WUNT</span>Wissenschaftliche Untersuchungen zum Neuen Testament</p>
</a><p class="abbre-para"><a id="page_13"><span class="abbre">ZNW</span>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</a><a id="page_14"></a></p><a id="page_14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbreviation.vue?8dd7b7fa